import { newStorage } from './storage';

const algoTableStorage = newStorage('TABLE_ALGO');

export default algoTableStorage;
